var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-fullpage"},[_c('img',{staticClass:"index-fullpage__img",attrs:{"src":_vm.heroSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }